import {mapActions} from 'vuex';
import Manager from '../modules/dro/api/Manager';
import UuidGenerator from '@/common/uuid/UuidGenerator';
import Constants from '../modules/dro/Constants';

export const loadDroInitData = {
  data() {
    return {
      loaded: false,
      sessionData: {},
      form: {},
      modalView: false,
    };
  },
  methods: {
    ...mapActions('dro/session', [
      'setSettings',
      'setAuditor',
      'setAssignee',
      'setUuid',
      'clearSession',
      'setIsSessionStarted',
      'setShouldStartIntervalAutomatically',
      'setStartedAt',
    ]),
    ...mapActions('appeals', [
      'setEntity',
    ]),
    onSessionSettingsSet(settings) {
      this.clearSession();
      this.setIsSessionStarted(true);
      this.setShouldStartIntervalAutomatically(true);
      let {auditor, assignee, uuid, entity} = this.sessionData;
      this.setAuditor(auditor);
      this.setAssignee(assignee);
      this.setSettings(settings);
      this.setUuid(uuid);
      this.setEntity(entity);
      this.setStartedAt(Math.round((new Date()).getTime() / 1000));
      this.sessionData = {};
    },
    async loadInitialData() {
      try {
        let clientId = this.clientId
            ? this.clientId
            : this.route.params.clientId;
        let response = await Manager.getSettings(clientId);
        let {settings, auditor, assignee} = response.data.data;
        for (let key of Object.keys(settings)) {
          if (settings[key]) {
            settings[key] = settings[key].toString();
          }
        }
        let uuid = UuidGenerator.v4();
        let entity = {
          id: uuid,
          type: Constants.ENTITY_TYPE,
        };
        this.sessionData = {auditor, assignee, uuid, entity};
        this.form = settings || {
          aimTypeId: '1',
          behaviourTypeId: '1',
          intervalDurationValue: null,
          intervalDurationUnitId: '1',
          behaviourDescription: '',
        };
      } catch (e) {
        console.error(e);
        this.$router.push({name: 'default'});
      }
    },
  },
  computed: {
    isCurrentUserSession() {
      let clientId = this.clientId ? this.clientId : this.route.params.clientId;
      return parseInt(clientId) === parseInt(this.assignee.id);
    },
    isCurrentUserStartedSessionBlock() {
      return this.isSessionStarted && this.isCurrentUserSession &&
          !this.modalView;
    },
  },
  async created() {
    if (!this.isSessionStarted || !this.isCurrentUserSession) {
      await this.loadInitialData();
    }
    this.loaded = true;
  },
};



// WEBPACK FOOTER //
// ./src/mixins/loadDroInitData.js